import React, { PropTypes } from 'react';
import { addLocaleData, IntlProvider } from 'react-intl';
// intl
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import pt from 'react-intl/locale-data/pt';
// Assets
import '../assets/semantic/semantic.min.css';
import './App.css';
import '../assets/fonts/FutureGlyphs.woff';
import '../assets/fonts/FutureGlyphs.ttf';
// Components
import Body from './layout/body/Body';
import messages from '../intl/index';

// Localization
addLocaleData([...en, ...es, ...pt]);

const propTypes = {
  children: PropTypes.element,
  locale: PropTypes.string.isRequired,
};

const App = (props) => {
  const locale = props.locale;
  const msgs = messages(locale);
  return (
    <IntlProvider locale={locale} key={locale} messages={msgs}>
      <Body {...props} />
    </IntlProvider>
  );
};

App.propTypes = propTypes;

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/